import addButton from '../../../assets/addButton.svg';
import showIcon from '../../../assets/showIcon.svg';
import hidenIcon from '../../../assets/hidenIcon.svg';
import enterArrow from '../../../assets/arrow-circle-right.svg';
import { formatCurrency } from '../../../utils/format';
import './BalanceManagement.css';
import { useEffect, useState } from 'react';
import { getBalance } from '../../../services/userInformationService';
import { useNavigate } from 'react-router-dom';
import { useOrderContext } from '../../../context/OrderContext';
import { ReactComponent as Loader } from '../../../assets/Spinner.svg';
import { useAuth } from '../../../context/AuthContext';
import { useBrandContext } from '../../../context/BrandContext';
import { useMapViewStore } from '../../../hooks/useMapViewStore';

interface MyComponentProps {
  user: any;
  value?: string;
}

const BalanceManagement: React.FC<MyComponentProps> = ({
  user,
  value = '0.00',
}) => {
  const [isValueOpen, setIsValueOpen] = useState<boolean>(() => {
    const savedState = localStorage.getItem('isValueOpen');
    return savedState !== null ? JSON.parse(savedState) : true;
  });
  const [balance, setBalance] = useState<any>(null);
  const navigate = useNavigate();
  const { isCreditCardPurchaseCompleted } = useOrderContext();
  //const location = useLocation();
  const auth = useAuth();
  const brandContext = useBrandContext();
  const { setHeaderHeight, headerRef } = useMapViewStore();

  //const routePaths = location.pathname.split('/');

  const handleValueView = () => {
    setIsValueOpen((prevState) => {
      const newState = !prevState;
      localStorage.setItem('isValueOpen', JSON.stringify(newState));
      return newState;
    });
  };

  useEffect(() => {
    if (auth.token) {
      getBalanceApi();
    }
  }, []);

  useEffect(() => {
    if (isCreditCardPurchaseCompleted) {
      getBalanceApi();
    }
  }, [isCreditCardPurchaseCompleted]);

  const getBalanceApi = async () => {
    try {
      const data = await getBalance();
      setBalance(formatCurrency(Number(data?.uwalBalance)));
    } catch (e) {
      console.log('ERRO GET SALDO API: ', e);
    }
  };

  useEffect(() => {
    if (!headerRef?.current) return;
    setHeaderHeight(headerRef.current.clientHeight);
  }, [balance]);

  return (
    <div className='balance-management-cotainer'>
      <div className='balance-current-value-container'>
        <p>Saldo</p>
        <div className='balance-current-value'>
          {isValueOpen ? (
            balance ? (
              balance
            ) : (
              <Loader
                style={{
                  backgroundColor: 'transparent !important',
                  width: '45px',
                  height: '50px',
                }}
              />
            )
          ) : (
            'R$ •••••••'
          )}
          <button onClick={handleValueView}>
            {isValueOpen ? (
              <img alt='show-icon' src={showIcon} />
            ) : (
              <img alt='hiden-icon' src={hidenIcon} />
            )}
          </button>
        </div>
        <div className='balance-current-value-extract'>
          <button
            onClick={() => navigate(`${brandContext.brandName}/extract`)}
            className='balance-current-value-extract-button'
            style={{ backgroundColor: brandContext.brandBgColor }}
          >
            Exibir extrato
            <img
              alt='enter-arrow-icon'
              style={{ marginLeft: '4px' }}
              src={enterArrow}
            />
          </button>
        </div>
      </div>
      <div className='add-credit'>
        <button
          onClick={() => navigate(`${brandContext.brandName}/paymentMethods`)}
          className='add-credit-button'
          style={{ backgroundColor: brandContext.brandBgColor }}
        >
          Adicionar
          <img alt='apple-icon' src={addButton} />
        </button>
      </div>
    </div>
  );
};

export default BalanceManagement;
